import moment from 'moment/moment';

import type { Moment } from 'moment/moment';

export const formatDateForView = (date?: Moment | null, format?: string) => {
  if (!date) return '';
  return moment(date).format(format || 'MMM DD');
};
